<template>
  <div class="searchRegulationsTitle">
    <div v-if="searchTitle == null">
      <div class="spin">
        <font-awesome-icon icon="compass" />
      </div>
      <div>
        加载中，请稍候......
      </div>
    </div>
    <div v-else class="main">
      <!-- 根据搜索结果展示标准清单 -->
      <el-row class="overview">
        <el-col :span="22">
          <span class="overview_text">
            共检索到<span v-if="searchTitle" class="num">{{searchTitle.length}}</span>条法规
          </span>
        </el-col>
        <el-col :span="2" style="text-align:right">
          <el-dropdown trigger="click">
            <img src="static/images/1DING-MINLOG.svg" type="image/svg+xml" class="logo">
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="menu('home')">网站首页 / 常规搜索</el-dropdown-item>
              <el-dropdown-item @click.native="menu('advanceSearch')">高级搜索 / 精准搜索</el-dropdown-item>
              <!-- <el-dropdown-item @click.native="menu('standards')" class="left show-md-and-up-only">国内标准 / 国际标准</el-dropdown-item>
              <el-dropdown-item @click.native="menu('regulations')" class="left show-md-and-up-only">法律法规 / 监管要求</el-dropdown-item> -->
              <el-dropdown-item divided @click.native="user('regulations')" class="left show-md-and-up-only">个人中心 / 消费记录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
      <div v-if="searchTitle.length == 0">
        <p style="margin-top:0.1rem;">
          未能检索到与关键字相匹配的内容，请重试其他关键字或放宽搜索条件。
        </p>
        <p style="margin-top:0.2rem;">
          注：本网站每天不定时更新相关内容，您也可以稍后重试。
        </p>
      </div>
      <div v-else class="results hideScrollbar">
        <div v-for="(item,index) in searchTitle" :key="index">
          <el-row :gutter="20" class="show-xs-and-up-only resultItem">
            <el-col :span="5">
              <span @click="openRegulations(item)">{{item.committee}} </span>
            </el-col>
            <el-col :span="15">
              <span @click="openRegulations(item)">{{item.regulations_name}}</span>
            </el-col>
            <el-col :span="3">
              <span @click="openRegulations(item)">
                {{item.published_date.substring(0,4)}}年
                {{item.published_date.substring(5,7)}}月
                {{item.published_date.substring(8,10)}}日
              </span>
            </el-col>
            <el-col :span="1">
              <a @click="downloadRegulations(item)">
                <font-awesome-icon icon="arrow-alt-circle-down" />
              </a>
            </el-col>
          </el-row>
          <div class="show-xs-down-only xs">
            <div @click="openRegulations(item)" class="committee">{{item.committee}} </div>
            <div @click="openRegulations(item)" class="xsItemName">{{item.regulations_name}}</div>
            <div @click="openRegulations(item)" class="xsItemName">
              {{item.published_date.substring(0,4)}}年
              {{item.published_date.substring(5,7)}}月
              {{item.published_date.substring(8,10)}}日
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Bus from "@/misc/bus.js";
  export default {
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.$store.dispatch("regulations/searchTitle", vm.$route.query.keywords);
      });
    },
    computed: {
      showPayment() {
        return this.$store.state.payment.showPayment;
      },
      keywords() {
        return this.$route.query.keywords;
      },
      searchTitle() {
        return this.$store.state.regulations.searchTitle;
      }
    },
    methods: {
      menu(params) {
        const {
          href
        } = this.$router.resolve({
          path: "/" + params
        });
        window.open(href, "_blank");
      },
      user() {
        this.$store.dispatch("users/getConsumptionHistory");
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
      },
      openRegulations(params) {
        const {
          href
        } = this.$router.resolve({
          path: "/showRegulations",
          query: {
            committee: params.committee,
            regulations_code: params.regulations_code,
            regulations_name: params.regulations_name
          }
        });
        window.open(href, "_blank");
      },
      downloadRegulations(params) {
        this.$store.dispatch("users/getConsumptionHistory");
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
        Bus.$emit("paied", false);
        this.$store.dispatch("order/setRechargeInfo", 5000);
        this.$store.dispatch("order/setOnceInfo", {
          description: params.regulations_name,
          category: "regulations_download",
          code: params.regulations_code,
          total_fee: 98, //单位分
          order_number: new Date().getTime(),
          body: "法规下载" // 发给微信端的订单描述
        });
      }
    }
  };
</script>

<style scoped>
  .searchRegulationsTitle {
    width: 100%;
    min-height: 100vh;
    /* padding: 0.2rem; */
    text-align: center;
  }

  .searchRegulationsTitle .main {
    text-align: left;
    padding: 0.1rem;
  }

  .searchRegulationsTitle .results {
    /* margin-top: 0.1rem; */
    height: calc(100vh - 1.1rem);
  }

  .searchRegulationsTitle .overview {
    border-bottom: 0.01rem solid gray;
  }

  .searchRegulationsTitle .overview_text {
    position: relative;
    padding: 0.05rem 0;
    font-size: 0.15rem !important;
    font-weight: 900 !important;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .searchRegulationsTitle .overview_text:after {
    position: absolute;
    content: '';
    width: 100%;
    height: 6px;
    left: 0;
    bottom: -3px;
    background: #aa0000;
  }

  .searchRegulationsTitle .num {
    background-color: #aa0000;
    color: white;
    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    letter-spacing: 0.01rem;
    padding: 0rem 0.05rem;
    margin: 0 0.1rem;
  }

  .searchRegulationsTitle .logo {
    margin: -0.05rem 0;
    height: 0.2rem;
    cursor: pointer;
  }

  .searchRegulationsTitle .resultItem {
    padding: 0.1rem 0;
    border-bottom: 1px solid #ccc
  }

  .searchRegulationsTitle .resultItem:hover {
    background-color: #2f2f2f;
    color: #efefef;
    cursor: pointer;
  }

  .searchRegulationsTitle .xs {
    border: 0.01rem solid gray;
    border-radius: 0.1rem;
    margin-top: 0.2rem;
    padding: 0.1rem
  }

  .searchRegulationsTitle .xs:hover {
    background-color: #eee;
    color: black
  }

  .searchRegulationsTitle .committee {
    border-bottom: 0.01rem solid gray;
    margin: 0;
    padding: 0;
    height: initial;
  }
</style>